// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gf-a";
export var fulfillmentFormRail = "_gf-9";
export var headerTitleRow = "_gf-c";
export var orderDetailsWrapper = "_gf-7";
export var orderLinkTrigger = "_gf-2";
export var paymentInformationGrid = "_gf-h";
export var paymentSummaryColumn = "_gf-i";
export var shipmentContainer = "_gf-b";
export var shipmentDetailsMainPane = "_gf-8";
export var shipmentNavigationCard = "_gf-5";
export var shipmentNavigationRail = "_gf-3";
export var shipmentNavigationRailHeader = "_gf-4";
export var shipmentSummaryFact = "_gf-e";
export var shipmentSummaryGrid = "_gf-d";
export var shipmentSummaryMetadataRow = "_gf-f";
export var shipmentSummaryTags = "_gf-g";
export var shipmentWorkspace = "_gf-0";
export var shipmentWorkspaceContent = "_gf-6";
export var shipmentWorkspaceHeader = "_gf-1";